import Backbone from 'lib/backbone';
import RadiosView from 'app/views/RadiosView';
import invokeCallbacks from 'app/NVTagCallbacks';
import { accounting } from 'lib/accounting';

var $ = Backbone.$;
var _ = Backbone._;

export default RadiosView.extend({
  __name__: 'PremiumGiftsView',
  type: 'gifts',
  events: {
    'keyup input[name="gift"]': 'cycleOptions',
    'change   :radio': 'onGiftSelected',
    'change .gift-variant-select': 'onVariantSelected'
  },
  initialize: function () {
    RadiosView.prototype.initialize.call(this);
    this.template = this.options.templates.premium_gifts;


    this.contributionAmountModel = this.options.formview.contributionAmountModel;
    this.contributionRecurrenceModel = this.options.formview.contributionRecurrenceModel;

    var defaultGift = this.def.gifts[0];
    this.setGift(defaultGift);

    // There are cases where the base amount can change without the total amount changing,
    // such as when base amount and coverCosts hit the max value
    this.listenTo(this.contributionAmountModel, 'change:baseAmount', this.amountChanged);
    this.listenTo(this.contributionRecurrenceModel, 'change:isRecurring', this.render);
  },
  context: function () {
    var self = this;
    var def = self.def;
    var context = {
      gifts: []
    };

    var currentAmount = this.contributionAmountModel.get('baseAmount');
    var currentSelection = this.selectedValue;

    context.gifts = _.map(def.gifts, function (gift) {
      var mappedGift = _.extend({}, gift);
      // ensure precision
      if (!gift.no_gift) {
        var activeThreshold = self.getThreshold(gift);
        if (activeThreshold) {
          mappedGift.threshold = accounting.formatMoney(activeThreshold);
          mappedGift.floatThreshold = self.toFloat(mappedGift.threshold, 2);
        }
        if (currentAmount < mappedGift.floatThreshold) {
          mappedGift.willIncrease = true;
        }
      }

      // check the current gift if selected
      if (gift.val === currentSelection) {
        mappedGift.checked = 'checked';
      }

      if (mappedGift.variants) {
        mappedGift.variants = _.map(mappedGift.variants, function (variant) {
          var mappedVariant = _.extend({}, variant);
          mappedVariant.options = _.map(variant.options, function (option) {
            var mappedOption = _.extend({}, option);
            if (option.availability === 'Backordered') {
              mappedOption.isBackordered = true;
            }
            if (option.availability === 'SoldOut') {
              mappedOption.isSoldOut = true;
            }
            return mappedOption;
          });
          mappedVariant.selectPlaceholder = self.resources.fill(
              self.resources.PrimaryResources.SelectAVariantOption, variant.name);
          return mappedVariant;
        });
      }

      if (!gift.no_gift && !(gift.variants && gift.variants.length) && gift.availability === 'Backordered') {
        mappedGift.backorderedMessage = self.resources.PrimaryResources.BackorderedMessage;
      }

      return mappedGift;
    });

    return invokeCallbacks('alterContext', { element: this.type, context: context, def: def }).context;
  },
  hasRealGifts: function () {
    return _.some(this.def.gifts, function (gift) {
      return !gift.no_gift;
    });
  },
  render: function () {
    if (!this.hasRealGifts()) {
      this.$el.hide();
      return this;
    }

    var context = this.context();
    var template = this.template(context);
    var self = this;

    self.$el.html(template);

    $('.gift-img-container').each(function (index, container) {
      var giftImgContainer = $(container).find('.gift-img');
      var img = $(giftImgContainer).find('img');
      // listen to the load event only once.
      // after the load event triggers, stop listening
      $(img).one('load', function () {
        $(container).css('background-image', 'none');
      });
    });

    if (self.selectedVariantOptionId) {
      self.$('.gift-variant-select').each(function () {
        var $select = $(this);
        if ($select.find('option[value="' + self.selectedVariantOptionId + '"]').length) {
          $select.val(self.selectedVariantOptionId);
        }
      });
    }

    return self;
  },
  multiple_fields: function () {
    return ['PremiumGift', 'PremiumGiftVariantOptionId'];
  },
  val: function () {
    var elm = $('input[name=gift]:checked');
    if (elm && elm[0]) {
      var result = { PremiumGift: elm[0].value };
      var gift = this.getGiftFromVal(elm[0].value);
      if (gift && gift.variants && gift.variants.length) {
        result.PremiumGiftVariantOptionId = this.selectedVariantOptionId || null;
      }
      return result;
    }
    return null;
  },
  setval: function (values) {
    if (values && values.PremiumGift) {
      RadiosView.prototype.setval.call(this, values.PremiumGift);
      this.selectedValue = parseInt(values.PremiumGift);
      var parsedVariantOptionId = parseInt(values.PremiumGiftVariantOptionId);
      if (!isNaN(parsedVariantOptionId)) {
        this.selectedVariantOptionId = parsedVariantOptionId;
      }
      this.render();
    }
  },
  setGift: function (gift) {
    // gift can be empty when 'no gift' is not configured as an option
    if (!gift) {
      delete this.selectedValue;
      delete this.selectedVariantOptionId;
      window.nvtag.trigger('giftChanged', { newAmount: 0 });
      return;
    }

    this.selectedValue = gift.val;
    this.selectedVariantOptionId = null;
    var floatThreshold = this.toFloat(this.getThreshold(gift) || 0, 2);
    window.nvtag.trigger('giftChanged', { newGift: gift, newAmount: floatThreshold });
  },
  getThreshold: function (gift) {
    var isRecurring = this.contributionRecurrenceModel.get('isRecurring');
    if (isRecurring && gift.recurring_threshold) {
      return gift.recurring_threshold;
    }
    return gift.threshold;
  },
  onGiftSelected: function (e) {
    var gift = this.getGiftFromVal(e.currentTarget.value);
    var currentAmount = this.contributionAmountModel.get('baseAmount');
    var thresholdValue = this.getThreshold(gift) || 0;


    thresholdValue = this.toFloat(thresholdValue, 2);
    if (thresholdValue > currentAmount) {
      this.options.formview.setPageInfoAlert([this.resources.PrimaryResources.PremiumGiftAmountIncreaseAlert]);
    }

    this.setGift(gift);
    // update text
    this.render();

    // Element was re-rendered, so focus removed. This gets it back.
    $('#' + e.target.id).focus();


    this.clearFeedback();
  },
  onVariantSelected: function (e) {
    var val = e.currentTarget.value;
    this.selectedVariantOptionId = val ? parseInt(val) : null;
    this.clearVariantErrors();
    this.clearBackorderMessage();
    if (val) {
      var $selected = $(e.currentTarget).find('option:selected');
      if ($selected.data('availability') === 'Backordered') {
        $(e.currentTarget).after('<small class="gift-backorder-message">' + _.escape(this.resources.PrimaryResources.BackorderedMessage) + '</small>');
      }
    }
  },
  amountChanged: function () {
    var currentAmount = this.contributionAmountModel.get('baseAmount');
    var currentGift = this.getSelectedGift();
    if (currentGift && currentAmount < this.toFloat(this.getThreshold(currentGift), 2)) {
      this.options.formview.setPageInfoAlert([this.resources.PrimaryResources.ContributionAmountTooSmall]);

      // The "no gift" option has val 0 if it exists
      // Set the gift to either the 'noGift' option or null if it doesn't exist
      var noGift = this.getGiftFromVal(0);
      this.setGift(noGift);
    }
    this.render();
  },
  clearFeedback: function () {
    $('.Premiums').removeClass('error');
    $('.Premiums > small.error').remove();
    this.$('.gift-variant-error').remove();
    return this;
  },
  renderFeedbackWithErrors: function (errors) {
    this.clearVariantErrors();
    if (errors.length) {
      if (this._variantErrorGift) {
        this.renderVariantErrors(this._variantErrorGift);
      } else {
        var premiums = $('.Premiums');
        premiums.addClass('error');
        premiums.append(this.error_template({ 'error_text': errors, 'behavior_classes': 'error' }));
      }
    } else {
      this.clearFeedback();
    }
    this._variantErrorGift = null;
    return errors;
  },
  errors: function () {
    var errors = [];
    this._variantErrorGift = null;
    if (!this.hasRealGifts()) {
      this.clearFeedback();
      this.trigger('valid');
      return errors;
    }
    var val = this.val();
    if (_.isNull(val) || _.isUndefined(val)) {
      this.clearFeedback();
      errors.push(this.resources.PrimaryResources.PleaseSelectGift);
    } else {
      var gift = this.getGiftFromVal(val.PremiumGift);
      if (gift && gift.variants && gift.variants.length && !val.PremiumGiftVariantOptionId) {
        this._variantErrorGift = gift;
        errors.push(this.resources.PrimaryResources.PleaseSelectVariantOption);
      }
    }

    errors = invokeCallbacks('alterErrors', {
      val: val,
      field_name: this.field_name(),
      errors: errors,
      def: this.def
    }).errors;
    this.trigger(errors.length ? 'invalid' : 'valid');
    return _.map(errors, _.bind(this.toError, this));
  },
  clearVariantErrors: function () {
    this.$('.gift-variant-error').remove();
  },
  clearBackorderMessage: function () {
    this.$('.gift-backorder-message').remove();
  },
  renderVariantErrors: function (gift) {
    var self = this;
    _.each(gift.variants, function (variant) {
      var $select = self.$('.gift-variant-select[data-variant-id="' + variant.id + '"]');
      if (!$select.val()) {
        var message = self.resources.fill(
            self.resources.PrimaryResources.SelectAVariantOptionToContinue, variant.name);
        $select.after('<small class="gift-variant-error" style="color: red; display: block;">' + _.escape(message) + '</small>');
      }
    });
  },
  getGiftFromVal: function (val) {
    return _.find(this.def.gifts, { val: parseInt(val) });
  },
  getSelectedGift: function () {
    var val = this.selectedValue;
    if (_.isNull(val) || _.isUndefined(val)) {
      return undefined;
    }
    return this.getGiftFromVal(val);
  }
});
